import { render, staticRenderFns } from "./WorkflowsSidebar.vue?vue&type=template&id=81759508&"
import script from "./WorkflowsSidebar.vue?vue&type=script&lang=ts&"
export * from "./WorkflowsSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/StratusCAD/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81759508')) {
      api.createRecord('81759508', component.options)
    } else {
      api.reload('81759508', component.options)
    }
    module.hot.accept("./WorkflowsSidebar.vue?vue&type=template&id=81759508&", function () {
      api.rerender('81759508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/workflows/WorkflowsSidebar.vue"
export default component.exports